// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3k5e0","label":"Labeled_label__32zfq","divider":"Labeled_divider__10Z-I"};